import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { getProjectState as getProjectStateConnect } from '../actions/savedState'

const ProjectLoad = ({ getProjectState, children }) => {
    const path = useLocation().pathname

    useEffect(() => {
        const path_array = path.split('/')
        const uuid = path_array[path_array.length - 2]
        getProjectState(uuid)
    }, [])

    return children
}

ProjectLoad.propTypes = {
    // redux actions
    getProjectState: PropTypes.func.isRequired
}

export default connect(null, dispatch => ({
    getProjectState: hash_input => dispatch(getProjectStateConnect(hash_input))
}))(ProjectLoad)
